import { useDateLocale } from '../useDateLocale'
import { useTimeZone } from '../useTimeZone'

/**
 * @deprecated Use {@link useDateLocale} or {@link useTimeZone} instead
 */
export function useUkTimeZone() {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  return { locale, timezone }
}
